export default (id, paperSize) => (
  window.open(`${process.env.API_LOCATION}/order/${id}/download-shipping-label?token=${localStorage.getItem('id_token')}&paper_size=${paperSize}`)
);



// WEBPACK FOOTER //
// ./src/app/services/order/downloadShippingLabel.js